module.exports = __webpack_public_path__ + "img/intro-common-manabou-logo.023e363f.jpg";